function OfferBanner() {
    return (
        <section className="py-8">
            <div className="mx-auto px-4">
                <div className="relative bg-gradient-to-r from-green-400 to-green-300 h-72 rounded-2xl flex items-center justify-center text-center overflow-hidden">

                    {/* Decorative illustration on right */}
                    <div className="absolute right-6 bottom-0 w-64 h-auto opacity-30">
                        <img
                            src="https://placehold.co/300x180/ffffff/cccccc?text=Illustration"
                            className="rounded-lg"
                            alt="Banner illustration"
                        />
                    </div>

                    {/* Content */}
                    <div className="relative z-10 max-w-lg">
                        {/* Promo Badge */}
                        <div className="inline-block bg-white text-green-700 font-semibold px-6 py-2 rounded-full shadow-md text-sm md:text-lg mb-4">
                            🎉 Flat ₹100 OFF on First Order via UPI
                        </div>

                        {/* CTA */}
                        <div>
                            <button className="bg-white text-green-700 font-bold py-3 px-8 rounded-lg shadow-lg hover:bg-gray-100 transition-colors duration-300">
                                Order Now
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default OfferBanner;
